/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import TableCellEllipsis from '../../../../../components/core/TableCellEllipsis/TableCellEllipsis';
import { TreatmentType } from '../../../../../models/core/treatments.type';
import { formatTimestampToString } from '../../../../../utils/formatter.utils';
import DataViewActions from './DataViewActions';

type DataViewProps = {
  data: TreatmentType[];
  confirmActionResult(item: TreatmentType, action: string, confirmed: boolean): void;
};

export default function DataView(props: DataViewProps) {
  const columns: ColumnsType<any> = [
    {
      title: 'Tratamento',
      key: 'residuoTratamento',
      dataIndex: 'residuoTratamento',
      sorter: (a: TreatmentType, b: TreatmentType) => a.residuoTratamento.localeCompare(b.residuoTratamento),
    },
    {
      title: 'Descrição',
      key: 'descricao',
      sorter: (a: TreatmentType, b: TreatmentType) => {
        return (a.descricao || '').localeCompare(b.descricao || '');
      },
      render: (row: TreatmentType) => (
        <TableCellEllipsis label={row?.descricao} numberOfChars={25} toolTipWidth={300} />
      ),
    },
    {
      title: 'Criado Por',
      key: 'criadoPor',
      sorter: (a: TreatmentType, b: TreatmentType) => a.criadoPor.localeCompare(b.criadoPor),
      render: (row: TreatmentType) => (
        <ProfileCardLink id={row.idCriadoPor} name={row.criadoPor} nameSize="sm" />
      ),
    },
    {
      title: 'Data Criação',
      key: 'dataCriacao',
      sorter: (a: TreatmentType, b: TreatmentType) =>
        new Date(a.dataCriacao).valueOf() - new Date(b.dataCriacao).valueOf(),
      render: (row: TreatmentType) => formatTimestampToString(row.dataCriacao),
    },
    {
      title: 'Modificado Por',
      key: 'modificadoPor',
      sorter: (a: TreatmentType, b: TreatmentType) =>
        (a.modificadoPor || '').localeCompare(b.modificadoPor || ''),
      render: (row: TreatmentType) => {
        if (row.idModificadoPor) {
          return (
            <ProfileCardLink id={row.idModificadoPor || ''} name={row.modificadoPor || ''} nameSize="sm" />
          );
        }
        return '-';
      },
    },
    {
      title: 'Data Modificação',
      key: 'dataModificacao',
      sorter: (a: TreatmentType, b: TreatmentType) => {
        const date = new Date();
        return new Date(a.dataModificacao || date).valueOf() - new Date(b.dataModificacao || date).valueOf();
      },
      render: (row: TreatmentType) => {
        if (row.dataModificacao) {
          return formatTimestampToString(row.dataModificacao);
        }
        return '-';
      },
    },
    {
      title: 'Ações',
      width: '130px',
      render: (row: TreatmentType) => (
        <DataViewActions item={row} confirmActionResult={props.confirmActionResult} />
      ),
    },
  ];

  return (
    <Table
      showSorterTooltip={false}
      dataSource={props.data}
      columns={columns}
      rowKey={(item: TreatmentType) => item.idResiduoTratamento}
      pagination={{
        pageSizeOptions: [10, 25, 50],
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
      }}
    />
  );
}
